module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/kulturniMapa-7a841dcf97fc7d15d67137fbe820be57.png";